import React, { useEffect, useState } from 'react';
import { useStateValue } from '../context/StateProvider';
import { getFirestore, collection, query, where, getDocs } from 'firebase/firestore';
import { RxTimer } from "react-icons/rx";
import { GrStatusGood } from "react-icons/gr";
import { ImProfile } from "react-icons/im";

const MyApplications = () => {
  const [{ user, Products }] = useStateValue();
  const firestore = getFirestore();
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  useEffect(() => {
    const fetchApplications = async () => {
        if (!user) {
            setLoading(false);
            return;
        }

        try {
            const applicationsRef = collection(firestore, 'applications');
            const q = query(applicationsRef, where('userId', '==', user.username));
            const querySnapshot = await getDocs(q);

            const apps = [];
            querySnapshot.forEach((doc) => {
                apps.push({ id: doc.id, ...doc.data() });
            });
            setApplications(apps);
            setError(null); // Clear any previous errors
        } catch (err) {
            console.error('Error fetching applications: ', err);
            setError('Failed to load applications. Please try again later.');
        } finally {
            setLoading(false);
        }
    };

    fetchApplications();
}, [user, firestore]);

  if (loading) {
    return <p className="text-center text-gray-500">Loading applications...</p>;
  }

  if (error) {
    return <p className="text-center text-red-500">{error}</p>;
  }

  return (
    <section className='mt-14 lg:mt-20 mb-5'>
      <div className="w-full max-w-4xl lg:max-w-6xl xl:max-w-7xl mx-auto p-6 bg-white shadow-sm rounded-lg flex flex-col gap-6">
        {/* Applications section */}
        <div className="w-full">
         
  <h1 className='text-[30px] text-[#0e55a8] text-[600] text-left items-start mb-10'>My Jobs</h1>
          {applications.length === 0 ? (
            <p className="text-center text-gray-500">No applications found.</p>
          ) : (
            <ul className="space-y-4">
              {applications.map((application) => {
                const product = Products.find(prod => prod.id === application.jobId);
                return (
                  <li key={application.id} className="p-4 border border-gray-200 rounded-lg shadow-sm">
                    <div className='flex flex-col lg:flex-row items-start lg:items-center justify-between'>
                      <div className="flex-1">
                        <h3 className="text-[#4b88e5]">
                          <span className='font-semibold text-[16px]'>Application ID: </span>
                          <span className='text-[13px]'>{application.id}</span>
                        </h3>
                        {product && (
                          <>
                            <h4 className="text-gray-600 mt-1">
                              <span className="font-semibold text-[16px]">Company Name: </span>
                              <span>{product.companyName}</span>
                            </h4>
                            <p className='text-[14px] mt-1 mb-3'>Job ID: {product.id}</p>
                          </>
                        )}
                        <a
  href={application.resumeUrl}
  target="_blank"
  rel="noopener noreferrer"
  className="text-blue-800 hover:underline flex gap-2  text-[14px] font-semibold"
>
  <ImProfile className="text-lg" /> View Resume
</a>

                      </div>
                      <div className="mt-3 lg:mt-0">
                        <p className='text-[14px] flex flex-row items-center gap-2'>
                          <RxTimer />
                          <span className='font-semibold'>Applied At:</span> {application.appliedAt.toDate().toLocaleString()}
                        </p>
                        <p className='text-[14px] flex flex-row items-center gap-2 mt-3'>
                          <GrStatusGood />
                          <span className='font-semibold'>Status:</span> {application.status}
                        </p>
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      </div>
    </section>
  );
};

export default MyApplications;
